import { GenericAutocomplete } from "../../../../common/GenericAutocomplete";
import { ChatObject } from "../../../../services/api/instances/botApi/types";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { MinusIcon } from "../../../../shared/icons/MinusIcon";
import styles from "./styles.module.css";

interface Props {
  chats: ChatObject[];
  chat: ChatObject | null;
  onSelectChat: (chat: ChatObject | null, id?: string) => void;
  emptyOptionLabel: string;
  isDisabled?: boolean;
  handleDeleteChatBlock?: () => void;
}

export const BotChatSelector = (props: Props) => {
  return (
    <div className={styles["user-container"]}>
      <GenericAutocomplete<ChatObject>
        options={props.chats}
        value={props.chat}
        onChange={props.onSelectChat}
        getLabel={(chat) => chat.chat_name}
        getValue={(chat) => chat.chat_id}
        getOptionKey={(chat) => chat.chat_id}
        isDisabled={props.isDisabled}
        emptyOptionLabel={props.emptyOptionLabel}
        autocompleteStyle={"select"}
      />
      {props.handleDeleteChatBlock && (
        <AppIconButton
          className={styles["icon-button"]}
          onClick={props.handleDeleteChatBlock}
        >
          <MinusIcon />
        </AppIconButton>
      )}
    </div>
  );
};
